import React from 'react';
import PropTypes from 'prop-types';
import { getIn, useFormikContext } from 'formik';

import { shouldCheckForCommunicationPermissions } from '~/components/Contacts/ContactUtils';
import RadioButtonGroupFormik from '~/components/core/Formik/RadioButtonGroupFormik';
import Heading from '~/components/core/TextComponents/Heading';
import useOrganization from '~/components/OrganizationContext';

import { useContact } from '../../useContact';

import { FORMIK_COMMUNICATION_FIELD_IDS } from './constants';
import { getFullCommunicationPath } from './utils';

const Permissions = ({ disabled }) => {
  const { communicationConfiguration } = useOrganization();
  const { isCompany, currentRole } = useContact();
  const { values } = useFormikContext();

  const checkForCommunicationPermissions = shouldCheckForCommunicationPermissions(
    communicationConfiguration?.is_communication_permission_required_for_all_contacts === true,
    isCompany,
    currentRole
  );

  if (!checkForCommunicationPermissions) {
    return null;
  }

  return (
    <div>
      <Heading variant="h4" className="mb-12">
        Permissions
      </Heading>
      <div className="grid grid-cols-2 items-center gap-20">
        <div>Send email messages</div>
        <RadioButtonGroupFormik
          className="justify-self-end"
          id={getFullCommunicationPath(FORMIK_COMMUNICATION_FIELD_IDS.IS_EMAILING_ALLOWED)}
          direction="row"
          options={[
            {
              text: 'No',
              optionValue: false,
            },
            {
              text: 'Yes',
              optionValue: true,
            },
          ]}
          showOnly={disabled || !getIn(values, getFullCommunicationPath(FORMIK_COMMUNICATION_FIELD_IDS.EMAILS))?.length}
          buttonVariant="default"
        />
      </div>
      <div className="grid grid-cols-2 items-center">
        <div>Send text messages</div>
        <RadioButtonGroupFormik
          className="justify-self-end"
          id={getFullCommunicationPath(FORMIK_COMMUNICATION_FIELD_IDS.IS_SMSING_ALLOWED)}
          direction="row"
          options={[
            {
              text: 'No',
              optionValue: false,
            },
            {
              text: 'Yes',
              optionValue: true,
            },
          ]}
          showOnly={disabled || !getIn(values, getFullCommunicationPath(FORMIK_COMMUNICATION_FIELD_IDS.PHONES))?.length}
          buttonVariant="default"
        />
      </div>
    </div>
  );
};

Permissions.propTypes = {
  disabled: PropTypes.bool,
};

export default Permissions;
